import { render } from "./FdicModal.vue?vue&type=template&id=6b9336fe&ts=true"
import script from "./FdicModal.vue?vue&type=script&lang=ts"
export * from "./FdicModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__